import {
    ApiHandler,
    HasOnSuccess,
    HasOnError,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    submitDeliveryDateForm,
    DeliveryDateRequest,
    DeliveryDateResponse,
} from "@tCentro/Services/NISPDPGetDeliveryDateService";

type HandlerType = ApiHandler<
    DeliveryDateRequest & HasOnSuccess<DeliveryDateResponse> & HasOnError,
    DeliveryDateResponse
>;

export const PopulateApiParameter: HandlerType = props => {
    const { qty, zipCode, email, productNumber, productTitle, productUrl } = props.parameter;

    props.apiParameter = {
        qty,
        zipCode,
        email,
        productNumber,
        productTitle,
        productUrl,
    };
};

export const CallApi: HandlerType = async props => {
    try {
        props.apiResult = await submitDeliveryDateForm(props.apiParameter);
    } catch (error: any) {
        props.apiResult = {
            message: error.errorJson?.message || error.errorMessage || "Unexpected server error",
        };
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    const msg = props.apiResult?.message?.toLowerCase() || "";

    if (msg.includes("error") || msg.includes("fail")) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    const msg = props.apiResult?.message?.toLowerCase() || "";

    if (msg.includes("success")) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, CallApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const submitDeliveryDateFormHandler = createHandlerChainRunner(chain, "submitDeliveryDateFormHandler");

export default submitDeliveryDateFormHandler;
